export default "__VITE_ASSET__BzW9KBQP__"